'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _mintUi = require('mint-ui');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

exports.default = {
  methods: {
    /**
     * 未登录
     */
    errToLogin: function errToLogin(err) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(err && err.data && err.data.code == 99)) {
                  _context.next = 4;
                  break;
                }

                _context.next = 3;
                return (0, _mintUi.MessageBox)({
                  title: '提示',
                  message: err.message
                });

              case 3:
                return _context.abrupt('return', _this.$router.push({ name: 'login', params: { id: _this.sysId } }));

              case 4:
                (0, _mintUi.Toast)({
                  message: err && err.message ? err.message : '网络请求出错',
                  position: 'bottom',
                  duration: 3000
                });

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/mixins/err.js
// module id = 449
// module chunks = 14